import { render } from "./IconForms.vue?vue&type=template&id=d0d8ccae"
const script = {}

import exportComponent from "/builds/enrian/design/design-system-documentation/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__